module.exports = __webpack_public_path__ + "static/media/informationIcon.7dcd41a7.svg";